export const authMiddleware = (store) => {
	return function(next){
	    return function(action) {
			const user = store.getState().user
			action.auth = user
			return next(action)
		}
	}
}
